module.exports = __webpack_public_path__ + "static/img/wx.4e57b04a.png";